module.exports = __webpack_public_path__ + "fonts/Roboto-700.b52fac2b.woff2";